import { useHeroState } from "../logic/useHeroState";
import { SimpleSpine } from "./SimpleSpine";

export function SelectedHeroSpine({ ...props }) {
  const { selectedHero } = useHeroState();
  return <SimpleSpine skin={selectedHero?.id} {...props} />;
}
